export default {
      id: "i-features-02-usage",
      viewBox: "0 0 20 23",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-02",
      toString: function () {
        return this.url;
      }
    }